'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var 分詞格式 = exports.分詞格式 = function 分詞格式(props, propName, componentName) {
  if (props[propName] !== '' && !/｜/.test(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Should follow 分詞 format.' + ' Validation failed.');
  }
  return null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/demo-ui/lib/vendor/CustomProptype.js
// module id = 85
// module chunks = 0